module.exports = __webpack_public_path__ + "img/saucer-squadron.a419a10f.jpg";